import HeaderVerde from '../HeaderVerde'
import Input from '../Input'
import Select from '../Select'
import Observacoes from '../Observacoes'
import Caixa from '../Caixa'
import CheckContainer from '../CheckContainer'
import CheckBox from '../CheckBox'
import React from 'react'

import { useSelector } from 'react-redux'

const Emergencia = (props) => {
    const modulo = props.modulo
    const updatedForm = useSelector((state) => state.addForm.qtdModulos[modulo])
    const condicional = useSelector((state) => state.addForm.modulos)
    const ficha = useSelector((state) => state.addForm.ficha)

    return (
        <>
            {RenderModulo()}
        </>
    )

    function RenderModulo() {
        let partes = []
        if(ficha[modulo]) var qtdFicha = ficha[modulo].length
        let quantidade = updatedForm || qtdFicha
        for (let n = 0; n < quantidade; n++) {
            partes.push(
                <Caixa>
                    <HeaderVerde texto="EMERGÊNCIA" />
                    <div style={{ textAlign: "left" }}>

                        <Input label="Emergência" nome="nomedaemergencia" modulo={modulo} index={n}
                            componentDisplay="inline-grid" widthWeb="60vw" widthMobile="80vw" marginR="3vw" />
                        <Input label="Número de Leitos" nome="leitos" modulo={modulo} index={n}
                            componentDisplay="inline-grid" widthWeb="10vw" widthMobile="80vw" marginR="3vw" tipo="number" />
                        <Input label="Nº de Pacientes Durante a Inspeção" nome="pacientesinspecao" modulo={modulo} index={n}
                            componentDisplay="block" widthWeb="5vw" widthMobile="80vw" marginR="3vw" tipo="number" />
                        <Input label="Nº de Pacientes Assistidos Pela Fisioterapia" nome="pacientesassistidos" modulo={modulo} index={n}
                            componentDisplay="block" widthWeb="5vw" widthMobile="80vw" marginR="3vw" tipo="number" />


                    </div>
                    <HeaderVerde texto="FISIOTERAPEUTA NO SETOR DURANTE A INSPEÇÃO" />
                    <div style={{ textAlign: "left" }}>
                        <Input label="Quantos Fisioterapeutas no Setor" nome="fisioescala" modulo={modulo} index={n}
                            componentDisplay="inline-grid" widthWeb="5vw" widthMobile="80vw" marginR="3vw" tipo="number" />
                        {RenderQtdFisio()}

                    </div>
                    <HeaderVerde texto="PROFISSIONAIS NA ESCALAS" />
                    <div style={{ textAlign: "left" }}>


                        <Input label="Quantidade Total de Profissionais na Escala" nome="escala" modulo={modulo} index={n}
                            widthWeb="5vw" widthMobile="80vw" marginR="3vw" tipo="number" />
                        <Select label="Assistência Fisioterapêutica 7 dias / semanas" nome="assistencia7" modulo={modulo} index={n}
                            componentDisplay="block" widthWeb="20vw" widthMobile="80vw" marginR="3vw"
                            array={["sim", "não"]} />
                        <Select label="Todos os Fisioterapeutas Possuem Capacitação em Suporte Básico de Vida (BLS)" nome="bls" modulo={modulo} index={n}
                            widthWeb="20vw" widthMobile="80vw" marginR="3vw"
                            array={["sim", "não"]} />

                    </div>
                    <HeaderVerde texto="LEGALIDADE" />
                    <div style={{ textAlign: "left" }}>
                        <Select label="CONFORMIDADE COM A RESOLUÇÃO COFFITO Nº  444/2014" nome="resolucao444" modulo={modulo} index={n}
                            componentDisplay="inline-grid" widthWeb="20vw" widthMobile="80vw" marginR="3vw"
                            array={["Sim", "Não"]} />
                    </div>
                </Caixa >
            )

            function RenderQtdFisio() {
                let campos = []
                if (condicional[modulo].length > 0) var array = condicional
                else var array = ficha
                var quantidade = array[modulo][n]["fisioescala"]
                if (array[modulo][n]["fisioescala"]) {
                    for (let i = 0; i < quantidade; i++) {
                        campos.push(
                            <div>
                                <Input label="Profissional" nome="nomedoprofissional"
                                    modulo={modulo} index={n} subModulo="nomedoprofissional" indexSub={i}
                                    componentDisplay="inline-grid" widthWeb="30vw" widthMobile="80vw" marginR="3vw" />
                                <Select label="Jornada de Trabalho" nome="jornada"
                                    modulo={modulo} index={n} subModulo="jornada" indexSub={i}
                                    componentDisplay="inline-grid" widthWeb="14vw" widthMobile="80vw" marginR="3vw"
                                    array={["Diarista", "Plantonista", "Ambos"]} />
                                <Select label="Horário de Trabalho" nome="hrtrabalho"
                                    modulo={modulo} index={n} subModulo="hrtrabalho" indexSub={i}
                                    componentDisplay="inline-grid" widthWeb="14vw" widthMobile="80vw" marginR="3vw"
                                    array={["12h diurno", "12h noturno", "6h matutino", "6h vespertino", "6h noturno", "24 horas"]} />
                            </div>
                        )
                    }
                }
                return campos
            }
        }
        return partes
    }
}

export default Emergencia